import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';

export const messages: Record<(ReferenceType | 'total'), IFormattedMessage> = {
  [ReferenceType.Manager]: { id: 'review.managersCount', defaultMessage: 'Manager(s)' },
  [ReferenceType.Peer]: { id: 'review.peersCount', defaultMessage: 'Peer(s)/colleague(s)' },
  [ReferenceType.Subordinate]: { id: 'review.subordinatesCount', defaultMessage: 'Subordinate(s)' },
  [ReferenceType.Educator]: { id: 'review.educatorsCount', defaultMessage: 'Educator(s)' },
  [ReferenceType.Other]: { id: 'review.othersCount', defaultMessage: 'Other(s)' },
  total: { id: 'candidateForm.finish.total', defaultMessage: 'Total References' }
};
